import { WIX_SHAPES_BASE_URL } from "./../media/media-url-consts.js";
const getShapeUrl = (src, getUrlOverride) => {
  if (src.url) {
    return src.url;
  }
  if (src.id) {
    const baseUrl = getUrlOverride ? getUrlOverride() : WIX_SHAPES_BASE_URL;
    return `${baseUrl}${src.id}`;
  }
  return "";
};
export {
  getShapeUrl
};
//# sourceMappingURL=get-shape-url.js.map
